import { BaseConfig, Nullable } from '.'

export type Plain = object

export type Config = BaseConfig & {
  type: 'enum'
  enum: object
} & (
    | {
        nullable: true
        defaultValue: string
      }
    | {
        nullable?: false
        defaultValue?: string
      }
  )

export type PlainResult<T, E = T[keyof T]> = E
export type Result<T extends Config> = Nullable<T, T['array'] extends true ? Array<T['enum'][keyof T['enum']]> : T['enum'][keyof T['enum']]>

const transformValue = (value: any, config: Config | Plain): string | null => {
  const enumerable = 'type' in config ? config.enum : config
  const nullable = (config as Config)?.nullable ?? false
  const defaultValue = 'defaultValue' in (config as Config) ? (config as Config)?.defaultValue : nullable ? null : Object.values(enumerable)[0]

  if (typeof value !== 'string') {
    return defaultValue
  }

  return value
}

export const transform = (value: any, config: Config | Plain): string | string[] | null => {
  if (config !== undefined && !('type' in config)) {
    return transformValue(value, config)
  }

  const array = config?.array ?? false

  if (array) {
    if (!Array.isArray(value)) {
      return []
    }

    return value.map((item) => transformValue(item, config)).filter(Boolean) as string[]
  }

  return transformValue(value, config)
}
